import { PropsWithChildren, useContext, useRef, useState } from "react";
import { ErrorsDisplay } from "../Shared/Error";
import toast from "react-hot-toast";
import { CardDivider } from "../Shared/CardDivider";
import { AppContext } from "../../../contexts/AppContext";
import ReCAPTCHA from "react-google-recaptcha";
import { API_PositionForwardToFriend } from "../../../apis/ApisPositions";

export type ForwardToAFriendProps = {
    finished: () => void,
    id: number,
}

export function ForwardToAFriendForm(props: PropsWithChildren<ForwardToAFriendProps>) {
    const [errors, setErrors] = useState<string[]>([]);

    const [email, setEmail] = useState<string>('');
    const emailInputRef = useRef<HTMLInputElement>(null);

    const [firstName, setFirstName] = useState<string>('');
    const firstNameInputRef = useRef<HTMLInputElement>(null);

    const [lastName, setLastName] = useState<string>('');
    const lastNameInputRef = useRef<HTMLInputElement>(null);

    const [friendEmail, setfriendEmail] = useState<string>('');
    const friendEmailInputRef = useRef<HTMLInputElement>(null);

    const [friendFirstName, setfriendFirstName] = useState<string>('');
    const friendFirstNameInputRef = useRef<HTMLInputElement>(null);

    const [friendLastName, setfriendLastName] = useState<string>('');
    const friendLastNameInputRef = useRef<HTMLInputElement>(null);

    const [comment, setComment] = useState<string>('');
    const commentInputRef = useRef<HTMLTextAreaElement>(null);

    const app = useContext(AppContext);

    const [captcha, setCaptcha] = useState<string>('');
    const [forawrded, setForawrded] = useState<boolean>(false);

    const reset = () => {
        setErrors([]);
        setEmail('');
        setFirstName('');
        setLastName('');
        setfriendEmail('');
        setfriendFirstName('');
        setfriendLastName('');
        setComment('');
        setCaptcha('');
        setForawrded(false);
    }

    function onChange(value: string) {
        setCaptcha(value);
    }

    const trySubmit = async () => {
        let errors: string[] = [];

        if (captcha == null || captcha == '' || captcha.length == 0) {
            errors = ([...errors, "Please complete the captcha"]);
        }

        if (friendEmail == null || friendEmail == '' || friendEmail.length == 0) {
            friendEmailInputRef?.current?.classList.remove("is-valid");
            friendEmailInputRef?.current?.classList.add("is-invalid");
            errors = ([...errors, "Please provide your friend's email"]);
        } else if (!friendEmail.includes("@")) {
            errors = ([...errors, "Please provide a valid friend's email"]);
            friendEmailInputRef?.current?.classList.remove("is-valid");
            friendEmailInputRef?.current?.classList.add("is-invalid");
        }
        else {
            friendEmailInputRef?.current?.classList.add("is-valid");
            friendEmailInputRef?.current?.classList.remove("is-invalid");
        }

        if (friendFirstName == null || friendFirstName == '' || friendFirstName.length == 0) {
            errors = ([...errors, "Please provide your friend's first name"]);
            friendFirstNameInputRef?.current?.classList.remove("is-valid");
            friendFirstNameInputRef?.current?.classList.add("is-invalid");
        }
        else {
            friendFirstNameInputRef?.current?.classList.add("is-valid");
            friendFirstNameInputRef?.current?.classList.remove("is-invalid");
        }

        if (friendLastName == null || friendLastName == '' || friendLastName.length == 0) {
            errors = ([...errors, "Please provide your friend's last name"]);
            friendLastNameInputRef?.current?.classList.remove("is-valid");
            friendLastNameInputRef?.current?.classList.add("is-invalid");
        }
        else {
            friendLastNameInputRef?.current?.classList.add("is-valid");
            friendLastNameInputRef?.current?.classList.remove("is-invalid");
        }

        if (comment == null || comment == '' || comment.length == 0) {
            errors = ([...errors, "Please provide a comment"]);
            commentInputRef?.current?.classList.remove("is-valid");
            commentInputRef?.current?.classList.add("is-invalid");
        }
        else {
            commentInputRef?.current?.classList.add("is-valid");
            commentInputRef?.current?.classList.remove("is-invalid");
        }

        if (!app.userLoggedIn) {
            if (lastName == null || lastName == '' || lastName.length == 0) {
                errors = ([...errors, "Please provide a last name"]);
                friendLastNameInputRef?.current?.classList.remove("is-valid");
                friendLastNameInputRef?.current?.classList.add("is-invalid");
            }
            else {
                friendLastNameInputRef?.current?.classList.add("is-valid");
                friendLastNameInputRef?.current?.classList.remove("is-invalid");
            }

            if (firstName == null || firstName == '' || firstName.length == 0) {
                errors = ([...errors, "Please provide a first name"]);
                firstNameInputRef?.current?.classList.remove("is-valid");
                firstNameInputRef?.current?.classList.add("is-invalid");
            }
            else {
                firstNameInputRef?.current?.classList.add("is-valid");
                firstNameInputRef?.current?.classList.remove("is-invalid");
            }

            if (email == null || email == '' || email.length == 0) {
                errors = ([...errors, "Please provide an email"]);
                emailInputRef?.current?.classList.remove("is-valid");
                emailInputRef?.current?.classList.add("is-invalid");
            }
            else {
                emailInputRef?.current?.classList.add("is-valid");
                emailInputRef?.current?.classList.remove("is-invalid");
            }
        }

        if (errors.length == 0) {
            var res = await API_PositionForwardToFriend(
                {
                    Captcha: captcha,
                    Comment: comment,
                    Email: email,
                    FirstName: firstName,
                    FriendEmail: friendEmail,
                    FriendFirstName: friendFirstName,
                    FriendLastName: friendLastName,
                    ID: props.id,
                    LastName: lastName
                });

            if (!res.Success) {
                errors = ([...errors, res.Error]);
            }
            else {
                toast.success("Forwarded");
                setForawrded(true);
            }
        }

        setErrors(errors);
    }

    return (
        <div className={`collapse`} id={`bdyCollapse_ForwardToAFriendForm`}>
            <div className="card-body">
                {!forawrded && <>
                    <CardDivider title={"Forward to a friend"} icon={""} />
                    <h5 className="mt-2">Enter details of the friend you want to send this vacancy to</h5>
                    {app.userLoggedIn && <p>Your configured first and last name will be included in the forwarded email.</p>}
                    <ErrorsDisplay errors={errors} />
                    <form>
                        <div className="row">
                            {!app.userLoggedIn && <div className="col-lg-12">
                                <label htmlFor="yourEmailControl" className="form-label-alt">Your email</label>
                                <input ref={emailInputRef} id="yourEmailControl" aria-label="Your email" className="form-control"
                                    value={email}
                                    type="text"
                                    onChange={t => {
                                        setEmail(t.currentTarget.value);
                                        emailInputRef?.current?.classList.remove("is-valid");
                                        emailInputRef?.current?.classList.remove("is-invalid");
                                    }} />
                                <div className="invalid-feedback">
                                    Please provide your email
                                </div>
                            </div>}
                            {!app.userLoggedIn && <div className="col-lg-6">
                                <label htmlFor="yourFirstName" className="form-label-alt">Your first name(s)</label>
                                <input ref={firstNameInputRef} id="yourFirstName" aria-label="Your first name(s)" className="form-control"
                                    value={firstName}
                                    type="text"
                                    onChange={t => {
                                        setFirstName(t.currentTarget.value);
                                        firstNameInputRef?.current?.classList.remove("is-valid");
                                        firstNameInputRef?.current?.classList.remove("is-invalid");
                                    }} />
                                <div className="invalid-feedback">
                                    Please provide your first name
                                </div>
                            </div>}
                            {!app.userLoggedIn && <div className="col-lg-6">
                                <label htmlFor="yourLastName" className="form-label-alt">Your last name</label>
                                <input ref={lastNameInputRef} id="yourLastName" aria-label="Your last name" className="form-control"
                                    value={lastName}
                                    type="text"
                                    onChange={t => {
                                        setLastName(t.currentTarget.value);
                                        lastNameInputRef?.current?.classList.remove("is-valid");
                                        lastNameInputRef?.current?.classList.remove("is-invalid");
                                    }} />
                                <div className="invalid-feedback">
                                    Please provide your last name
                                </div>
                            </div>}
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <label htmlFor="friendEmail" className="form-label-alt">Friend's email</label>
                                <input ref={friendEmailInputRef} id="friendEmail" aria-label="Friend's email" className="form-control"
                                    value={friendEmail}
                                    type="text"
                                    onChange={t => {
                                        setfriendEmail(t.currentTarget.value);
                                        friendEmailInputRef?.current?.classList.remove("is-valid");
                                        friendEmailInputRef?.current?.classList.remove("is-invalid");
                                    }} />
                                <div className="invalid-feedback">
                                    Please provide your friend's email
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="friendFirstName" className="form-label-alt">Friend's first name(s)</label>
                                <input ref={friendFirstNameInputRef} id="friendFirstName" aria-label="Friend's first name(s)" className="form-control"
                                    value={friendFirstName}
                                    type="text"
                                    onChange={t => {
                                        setfriendFirstName(t.currentTarget.value);
                                        friendFirstNameInputRef?.current?.classList.remove("is-valid");
                                        friendFirstNameInputRef?.current?.classList.remove("is-invalid");
                                    }} />
                                <div className="invalid-feedback">
                                    Please provide your friend's first name(s)
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="friendLastName" className="form-label-alt">Friend's last name</label>
                                <input ref={friendLastNameInputRef} id="friendLastName" aria-label="Friend's last name" className="form-control"
                                    value={friendLastName}
                                    type="text"
                                    onChange={t => {
                                        setfriendLastName(t.currentTarget.value);
                                        friendLastNameInputRef?.current?.classList.remove("is-valid");
                                        friendLastNameInputRef?.current?.classList.remove("is-invalid");
                                    }} />
                                <div className="invalid-feedback">
                                    Please provide your friend's last name
                                </div>
                            </div>
                        </div>
                        <div className="col-auto">
                            <label htmlFor="yourComment" className="form-label-alt">Comment</label>
                            <textarea ref={commentInputRef} id="yourComment" aria-label="Comment" className="form-control"
                                value={comment}
                                rows={4}
                                maxLength={1000}
                                onChange={t => {
                                    setComment(t.currentTarget.value);
                                    commentInputRef?.current?.classList.remove("is-valid");
                                    commentInputRef?.current?.classList.remove("is-invalid");
                                }} />
                            <div className="invalid-feedback">
                                Please provide a comment
                            </div>
                        </div>
                        <div className="d-flex justify-content-center mt-3">
                            <ReCAPTCHA
                                sitekey="6LcHQ70SAAAAAE-diS09IHJStkyF46bXBxVQrDjQ"
                                onChange={onChange}
                            />
                        </div>
                        <div className="d-flex justify-content-between mt-3">
                            <button className="btn btn-outline-soft" onClick={(e) => { e.preventDefault(); props.finished(); }}>Cancel</button>
                            <button className="btn btn-alt" onClick={(e) => { e.preventDefault(); trySubmit(); }}>Forward</button>
                        </div>
                    </form>
                </>}
                {forawrded && <><div className="alert alert-success">
                    Forwarded to your friend
                </div>
                    <button className="btn btn-outline-soft" onClick={(e) => { e.preventDefault(); reset(); }}>Forward to another friend</button>
                </>}
            </div>
            <hr className="text-alt thick-hr mx-3" />
        </div >
    );
}